import { Collapsible } from '@highlight/ui'
import { twMerge } from 'tailwind-merge'

interface ActionReferenceContentProps extends React.ComponentProps<typeof Collapsible.Content> {}

function ActionReferenceContent({ className, innerClassName, children, ...props }: ActionReferenceContentProps) {
  return (
    <Collapsible.Content
      onClick={(e) => e.stopPropagation()}
      className={className}
      innerClassName={twMerge(
        'flex-row relative ml-3 text-sm items-center font-normal -mt-1 text-foreground-secondary px-3 py-1 break-words',
        innerClassName,
      )}
      {...props}
    >
      <span className="bg-border absolute -left-1 top-0 h-full w-px" />
      {children}
    </Collapsible.Content>
  )
}

export { ActionReferenceContent }
